import React, { useState } from "react";
import Modal from "../../molecules/modal/modal";
import "./medal-modal.scss";
import Button from "../../atoms/button/button";
import bgMedal from "../../../assets/bg-medal.jpg";

interface IMedalModalProps {
  children?: any;
}

const Title = ({ children }: any) => {
  return <h2 className="medal-modal__title">{children}</h2>;
};

const Icon = ({ element }: { element: any }) => {
  return (
    <>
      <div className="medal-modal__iconWrapper">
        <img src={bgMedal} alt="" />
        {element}
      </div>
      <div style={{ height: "190px" }}></div>
    </>
  );
};

const MedalModal = (props: IMedalModalProps) => {
  const [showMedal, setShowMedal] = useState(true);
  const { children } = props;

  return (
    <div className="medal-modal">
      <Modal open={showMedal} handleClose={() => setShowMedal(false)}>
        <div>
          {children}
          <Button gtmClass="secondary" onClick={() => setShowMedal(false)}>
            Continuar
          </Button>
        </div>
      </Modal>
    </div>
  );
};

MedalModal.Icon = Icon;
MedalModal.Title = Title;

export default MedalModal;
